module.exports = __webpack_public_path__ + "static/media/policy_light.c036d1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/policy_light.png
// module id = 3537
// module chunks = 3